<template>
    <div>
        <el-cascader
            clearable
            collapse-tags
            collapse-tags-tooltip
            :size="attr && attr.size ? attr.size : ''"
            :disabled="attr && attr.disabled ? true : false"
            v-model="value"
            :props="cascaderProps"
            :options="options" />
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, provide, inject, watch } from 'vue'
    import { linkageAjaxRemoteMethod } from '@/utils/function'
    export default defineComponent({
        props: {
            attr: {
                type: [Array, Object],
                default: () => {}
            },
            config: {
                type: [Array, Object],
                default: () => {}
            },
            formOptions: {
                type: [Array, Object],
                default: () => {}
            },
            modelValue: {
                type: [Number, String, Array, Object],
                default: ''
            }
        },
        setup(props, context) {
            const { proxy } = getCurrentInstance()

            const value = ref(props.modelValue)
            const options = ref(props.formOptions)
            const attr = ref(props.attr)
            const config = ref(props.config)
            const cascaderProps = ref()
            const lazyLoad = (node, resolve) => {
                let url = attr.value.url
                if (!url) {
                    url = attr.value.params
                    url.level = node.level
                }
                let q = 0
                if (node.value) q = node.value
                linkageAjaxRemoteMethod(q, url, proxy).then((data) => {
                    resolve(data)
                })
            }
            cascaderProps.value = {
                multiple: attr.value && attr.value.multiple && (attr.value.multiple === true || attr.value.multiple === 'true'),
                lazy: attr.value && attr.value.lazy && (attr.value.lazy === true || attr.value.lazy === 'true'),
                lazyLoad: lazyLoad,
                disabled: attr.value && attr.value.disabled && (config.value.disabled === true || attr.value.disabled === 'true'),
                value: config.value && config.value.value ? config.value.value : 'value',
                label: config.value && config.value.label ? config.value.label : 'label',
                children: config.value && config.value.children ? config.value.children : 'children',
                leaf: config.value && config.value.leaf ? config.value.leaf : 'leaf',
                emitPath: config.value && config.value.emitPath && (config.value.emitPath === true || config.value.emitPath === 'true')
            }
            return {
                options,
                value,
                cascaderProps,
                lazyLoad
            }
        },
        watch: {
            value(newv, oldv) {
                this.$emit('update:modelValue', newv)
            }
        }
    })
</script>

<style>

</style>
